// API BASE URL
// export const BASE_URL = 'https://api.buku.kemdikbud.go.id';
export const BASE_URL = 'https://api.buku.cloudapp.web.id';
